import parse from "html-react-parser";
import { drawStatusMessage, drawStatus } from "../../constants/draw-status";
import { useDrawDetails } from "../../context/draw-details";
import { getDisplayDateTime } from "../../utilities/get-display-date";
import styles from "./styles";
import global from "../../styles";

const DrawDetails = () => {
  const [state] = useDrawDetails();
  const {
    loading,
    content: { drawTitle, drawDescription, drawPrice },
    drawDetails: { status, dateOpenUtc, dateCloseUtc },
  } = state;
  return (
    <div className={`${styles.wrapper} ${global.leavesden2}`}>
      {!loading && (
        <>
          <h1 className={global.barnsley5}>{drawTitle}</h1>
          <p>{parse(drawDescription)}</p>
          <div>
            <span>{drawPrice}</span>
            {status?.toUpperCase() !== drawStatus.OPEN && (
              <p>
                {status?.toUpperCase() !== drawStatus.LIVE
                  ? drawStatusMessage[status?.toUpperCase()]
                  : getDisplayDateTime(dateOpenUtc)}
              </p>
            )}
          </div>
          {status?.toUpperCase() === drawStatus.OPEN && (
            <p>{`Draw closes ${getDisplayDateTime(dateCloseUtc)}`}</p>
          )}
        </>
      )}
    </div>
  );
};

export default DrawDetails;
